// Lets any page tell the WhatsApp float where the founder currently is so the
// pre-filled message carries context (e.g. "Step 3 of 5 — Upload documents").
let current = null;
export const setWaContext = (ctx) => {
  current = ctx || null;
  try { window.dispatchEvent(new CustomEvent("clinq:wa-context", { detail: current })); } catch (_e) { /* ignore */ }
};
export const getWaContext = () => current;
